// ملف VisaNetRegistration.js - صفحة جديدة تحت التطوير
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Construction, ArrowRight, Globe, FileText, Users, Calendar } from 'lucide-react';

const VisaNetRegistration = () => {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto p-4 text-right" dir="rtl">
      <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">تسجيل النت - التأشيرات</h1>
          <button 
            onClick={() => navigate('/')}
            className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded flex items-center gap-2"
          >
            <ArrowRight className="w-4 h-4" />
            العودة للرئيسية
          </button>
        </div>

        {/* تحت التطوير */}
        <div className="min-h-[400px] flex flex-col items-center justify-center">
          <div className="text-center">
            <Construction className="w-24 h-24 text-orange-500 mx-auto mb-6" />
            <h2 className="text-3xl font-bold text-gray-700 mb-4">صفحة تحت التطوير</h2>
            <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
              نعمل حالياً على تطوير نظام تسجيل النت للتأشيرات. 
              ستكون هذه الصفحة متاحة قريباً بميزات متقدمة.
            </p>
            
            {/* المميزات المخططة */}
            <div className="bg-blue-50 rounded-lg p-6 max-w-2xl mx-auto">
              <h3 className="text-xl font-semibold text-blue-800 mb-4">المميزات المخططة:</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-right">
                <div className="flex items-center gap-3">
                  <Globe className="w-5 h-5 text-blue-600" />
                  <span className="text-blue-700">تسجيل طلبات النت الجديدة</span>
                </div>
                <div className="flex items-center gap-3">
                  <FileText className="w-5 h-5 text-blue-600" />
                  <span className="text-blue-700">إدارة الوثائق المطلوبة</span>
                </div>
                <div className="flex items-center gap-3">
                  <Users className="w-5 h-5 text-blue-600" />
                  <span className="text-blue-700">ربط المتقدمين بالطلبات</span>
                </div>
                <div className="flex items-center gap-3">
                  <Calendar className="w-5 h-5 text-blue-600" />
                  <span className="text-blue-700">جدولة المواعيد</span>
                </div>
              </div>
            </div>

            {/* معلومات إضافية */}
            <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded-lg max-w-md mx-auto">
              <p className="text-yellow-800 text-sm">
                <strong>ملاحظة:</strong> يمكنك استخدام صفحة "الاختيار والتجهيزات" 
                في قسم الجوازات للوظائف الحالية المتعلقة بالنت.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisaNetRegistration;